export const output = (data: string[], output_name: string, media_format: string, format: string, total_length: number) => {
    let outputFile = output_name + format;
    var blob;
    if (format === '.csv') {
        blob = csv(data);;
    } else if (format === '.txt') {
        blob = txt(data);
    } else if (format === '.eaf') {
        blob = eaf(data, output_name + media_format);
    } else if (format === '.TextGrid') {
        blob = TextGrid(data, total_length);
    }

    if (blob !== null && blob !== undefined) {
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = outputFile;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
}

const csv = (data: string[]): Blob => {
    const blob = new Blob(data as BlobPart[]);
    return blob;
}

const txt = (data: string[]): Blob => {
    var text: string[] = data.map((element) => { return element.split(',')[0] + '\n' });
    const blob = new Blob(text as BlobPart[]);
    return blob;
}

const eaf = (data: string[], media_name: string): Blob => {
    const interval_buffer = 0.3;
    let intervals = addIntervalBreaks(data, interval_buffer, -1, false);
    let date = new Date().toISOString();
    let header: string[] = ['<?xml version="1.0" encoding="UTF-8"?>\n',
    '<ANNOTATION_DOCUMENT AUTHOR="" DATE="' + date + '"\n',
    '    FORMAT="3.0" VERSION="3.0"\n',
    '    xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:noNamespaceSchemaLocation="http://www.mpi.nl/tools/elan/EAFv3.0.xsd">\n',
    '    <HEADER MEDIA_FILE="" TIME_UNITS="milliseconds">\n',
    '        <MEDIA_DESCRIPTOR MEDIA_URL="' + media_name + '" />\n',
    '        <PROPERTY NAME="URN">urn:nl-mpi-tools-elan-eaf:f1c984f0-9484-44ee-9e94-4d61c5d25a11</PROPERTY>\n',
    '        <PROPERTY NAME="lastUsedAnnotationId">' + intervals.length + '</PROPERTY>\n',
    '    </HEADER>\n'
    ];
    let time_orders: string[] = [];
    let tier: string[] = [];

    time_orders.push('    <TIME_ORDER>\n');
    tier.push('    <TIER LINGUISTIC_TYPE_REF="default-lt" TIER_ID="default">\n');
    for (let i = 0; i < intervals.length; i++) {
        let splits = intervals[i].split(',');
        let content = splits[0];
        let start = Math.floor(parseFloat(splits[1]) * 1000);
        let end = Math.floor(parseFloat(splits[2]) * 1000);
        let firstIndex = 2 * i + 1;
        let secondIndex = 2 * i + 2;
        time_orders.push('        <TIME_SLOT TIME_SLOT_ID="ts' + firstIndex + '" TIME_VALUE="' + start + '"/>\n');
        time_orders.push('        <TIME_SLOT TIME_SLOT_ID="ts' + secondIndex + '" TIME_VALUE="' + end + '"/>\n');
        tier.push('        <ANNOTATION>\n');
        tier.push('            <ALIGNABLE_ANNOTATION ANNOTATION_ID="a' + (i+1) + '"\n');
        tier.push('                TIME_SLOT_REF1="ts' + firstIndex + '" TIME_SLOT_REF2="ts' + secondIndex + '">\n');
        tier.push('                <ANNOTATION_VALUE>' + content + '</ANNOTATION_VALUE>\n');
        tier.push('        </ALIGNABLE_ANNOTATION>\n')
        tier.push('        </ANNOTATION>\n');
    }
    time_orders.push('    </TIME_ORDER>\n');
    tier.push('    </TIER>\n');
    let footer: string[] = ['    <LINGUISTIC_TYPE GRAPHIC_REFERENCES="false"\n',
    '        LINGUISTIC_TYPE_ID="default-lt" TIME_ALIGNABLE="true"/>\n',
    '    <CONSTRAINT\n',
    '        DESCRIPTION="Time subdivision of parent annotation\'s time interval, no time gaps allowed within this interval" STEREOTYPE="Time_Subdivision"/>\n',
    '    <CONSTRAINT\n',
    '        DESCRIPTION="Symbolic subdivision of a parent annotation. Annotations refering to the same parent are ordered" STEREOTYPE="Symbolic_Subdivision"/>\n',
    '    <CONSTRAINT DESCRIPTION="1-1 association with a parent annotation" STEREOTYPE="Symbolic_Association"/>\n',
    '    <CONSTRAINT\n',
    '        DESCRIPTION="Time alignable annotations within the parent annotation\'s time interval, gaps are allowed" STEREOTYPE="Included_In"/>\n',
    '</ANNOTATION_DOCUMENT>'];

    let text = header.concat(time_orders).concat(tier).concat(footer);
    return new Blob(text as BlobPart[]);
}

const TextGrid = (data: string[], total_length: number): Blob => {
    const interval_buffer = 0.3;
    let intervals = addIntervalBreaks(data, interval_buffer, total_length, true);
    // header info
    var textgrid: string[] = ['File type = "ooTextFile"\n',
        'Object class = "TextGrid"\n',
        '\n',
        'xmin = 0\n',
        'xmax = ' + total_length + '\n',
        'tiers? <exists>\n',
        'size = 1\n',
        'item []:\n',
        '    item [1]:\n',
        '        class = "IntervalTier"\n',
        '        name = "sentence"\n',
        '        xmin = 0\n',
        '        xmax = ' + total_length + '\n',
        '        intervals: size = ' + intervals.length + '\n'];
    for (let i = 0; i < intervals.length; i++) {
        var splits = intervals[i].split(',');
        textgrid.push('        intervals[' + (i + 1) + ']:\n');
        textgrid.push('            xmin = ' + splits[1] + '\n');
        textgrid.push('            xmax = ' + splits[2]); // already has the newline character
        textgrid.push('            text = "' + splits[0] + '"\n');
    }
    const blob = new Blob(textgrid as BlobPart[]);
    return blob;
}

const addIntervalBreaks = (data: string[], interval_buffer: number, total_length: number, fill_empty_intervals: boolean): string[] => {
    // first remove all empty intervals
    var intervals: string[] = [];
    data.forEach((element) => {
        if (element.split(',')[0] !== '' && element.split(',')[0] !== 'Text') {
            intervals.push(element);
        }
    });
    // try to shift each interval back by interval_buffer
    for (let i = 0; i < intervals.length; i++) {
        let thisTime = parseFloat(intervals[i].split(',')[1]);
        let lastTime = i === 0 ? 0 : parseFloat(intervals[i - 1].split(',')[2]);
        let diff = thisTime - lastTime;
        if (diff > interval_buffer * 2) {
            thisTime -= interval_buffer;
        } else if (diff > interval_buffer) {
            thisTime -= interval_buffer;
            lastTime += diff - interval_buffer;
        } else {
            thisTime -= diff;
        }
        var thisSplits = intervals[i].split(',');
        intervals[i] = thisSplits[0] + ',' + thisTime + ',' + thisSplits[2];
        if (i !== 0) {
            var lastSplits = intervals[i - 1].split(',');
            intervals[i - 1] = lastSplits[0] + ',' + lastSplits[1] + ',' + lastTime + '\n';
        }
    }
    if (fill_empty_intervals) {
        // add empty intervals back in
        for (let i = intervals.length - 1; i > 0; i--) {
            let thisTime = parseFloat(intervals[i].split(',')[1]);
            let lastTime = parseFloat(intervals[i - 1].split(',')[2]);
            if (thisTime !== lastTime) {
                // add at index
                intervals.splice(i, 0, ',' + lastTime + ',' + thisTime + '\n');
            }
        }
        // add first and last intervals
        var firstTime = parseFloat(intervals[0].split(',')[1]);
        if (firstTime !== 0) {
            intervals.splice(0, 0, ',0,' + firstTime + '\n')
        }
        var lastTime = parseFloat(intervals[intervals.length - 1].split(',')[2]);
        if (lastTime !== total_length) {
            intervals.splice(intervals.length, 0, ',' + lastTime + ',' + total_length + '\n')
        }

    }
    return intervals;
}